import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

const formatTel = (value) => {
  let v = (value || '').replace(/\D/g, '');
  if (v.length <= 10) {
    v = v.replace(/^(\d{2})(\d)/, '($1) $2');
    v = v.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    v = v.replace(/^(\d{2})(\d)/, '($1) $2');
    v = v.replace(/(\d{5})(\d)/, '$1-$2');
  }
  return v;
};

const TelField = ({ field, useFormRef, schema, label, ...props }) => {
  const { control } = useFormRef;
  const fieldSchema = schema ? yup.reach(schema, field) : null;

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <TextField
          fullWidth
          inputRef={ref}
          label={fieldSchema?.spec?.label ?? label ?? 'Telefone'}
          required={!!fieldSchema?.exclusiveTests?.required}
          error={!!error}
          helperText={error?.message}
          value={value ?? ''}
          onChange={(e) => {
            const masked = formatTel(e.target.value);
            onChange(masked);
          }}
          onBlur={onBlur}
          InputLabelProps={{
            shrink: Boolean(value) || undefined,
            ...props.InputLabelProps,
          }}
          {...props}
        />
      )}
    />
  );
};

export default TelField;
